'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.otherChildStyles = exports.lastChildStyles = exports.firstChildStyles = exports.DividerButton = exports.DividerButtonWrapper = exports.BeautifulButtonGroup = undefined;
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n'], ['\n  ', '\n']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      display: ', ';\n      flex-direction: row;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-items: center;\n\n      ', '\n    '], ['\n      display: ', ';\n      flex-direction: row;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-items: center;\n\n      ', '\n    ']),
  _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n        border-radius: 100px;\n        box-shadow: 0 3px 5px 0 rgba(74, 74, 74, 0.2), 0 1px 18px 0 rgba(74, 74, 74, 0.12), 0 6px 10px 0 rgba(74, 74, 74, 0.14);\n      '], ['\n        border-radius: 100px;\n        box-shadow: 0 3px 5px 0 rgba(74, 74, 74, 0.2), 0 1px 18px 0 rgba(74, 74, 74, 0.12), 0 6px 10px 0 rgba(74, 74, 74, 0.14);\n      ']),
  _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid #f78323;\n  border-bottom: 1px solid #f78323;\n  ', ';\n  display: flex;\n  align-items: center;\n  height: ', ';\n'], ['\n  border-top: 1px solid #f78323;\n  border-bottom: 1px solid #f78323;\n  ', ';\n  display: flex;\n  align-items: center;\n  height: ', ';\n']),
  _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  width: 2px;\n  background: ', ';\n  height: ', ';\n'], ['\n  width: 2px;\n  background: ', ';\n  height: ', ';\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _height = require('../../../behaviors/height');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BeautifulButtonGroup = _styledComponents2.default.div(_templateObject, function (_ref) {
  var shadow = _ref.shadow,
    fluid = _ref.fluid;
  return (0, _styledComponents.css)(_templateObject2, fluid ? 'flex' : 'inline-flex', shadow && (0, _styledComponents.css)(_templateObject3));
});
var DividerButtonWrapper = _styledComponents2.default.div(_templateObject4, function (_ref2) {
  var outline = _ref2.outline;
  return !outline && 'background: #f78323;';
}, function (_ref3) {
  var size = _ref3.size;
  return (0, _height.buttonHeightNumber)(size) - 2 + 'px';
});
var DividerButton = _styledComponents2.default.div(_templateObject5, function (_ref4) {
  var outline = _ref4.outline;
  return outline ? '#f78323' : '#C95A11';
}, function (_ref5) {
  var size = _ref5.size;
  return (0, _height.buttonHeightNumber)(size) - 16 + 'px';
});
var firstChildStyles = {
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  borderRight: 0
};
var lastChildStyles = {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  borderLeft: 0
};
var otherChildStyles = {
  borderRadius: 0,
  borderRight: 0,
  borderLeft: 0
};
exports.BeautifulButtonGroup = BeautifulButtonGroup;
exports.DividerButtonWrapper = DividerButtonWrapper;
exports.DividerButton = DividerButton;
exports.firstChildStyles = firstChildStyles;
exports.lastChildStyles = lastChildStyles;
exports.otherChildStyles = otherChildStyles;